/** @format */

// src/components/RelayForm.js

import { useState, useEffect } from '@wordpress/element';

const RelayForm = ({ meetingPostId, onSave, onCancel, initialData }) => {
	const [formData, setFormData] = useState({
		relayName: '',
		sexCode: 'M',
		clubName: '',
		clubCode: '',
		countryCode: 'JM',
		countryName: 'Jamaica',
	});

	const [clubsList, setClubsList] = useState({});
	const [countriesList, setCountriesList] = useState({});

	const getGlobalRoutingData = () => {
		if (typeof window !== 'undefined') {
			if (window.ammData) return window.ammData;
			if (window.wp?.ajax?.settings?.ammData) return window.wp.ajax.settings.ammData;
		}
		return null;
	};

	// Fetch relational lists securely via absolute REST endpoint
	useEffect(() => {
		const globalRouting = getGlobalRoutingData();
		if (globalRouting?.api_url) {
			fetch(`${globalRouting.api_url}/meta`, {
				headers: { 'X-WP-Nonce': globalRouting.nonce || '' },
			})
				.then((res) => {
					if (!res.ok) throw new Error('Metadata response failed verification.');
					return res.json();
				})
				.then((data) => {
					if (data) {
						setClubsList(data.clubs || {});
						setCountriesList(data.countries || {});
					}
				})
				.catch((err) => console.error('Error linking metadata assets:', err));
		}
	}, []);

	// Sync initial data cleanly without age constraints
	useEffect(() => {
		if (initialData) {
			setFormData({
				relayName: initialData.relayName || '',
				sexCode: initialData.sexCode || 'M',
				clubName: initialData.clubName || '',
				clubCode: initialData.clubCode || '',
				countryCode: initialData.countryCode || 'JM',
				countryName: initialData.countryName || 'Jamaica',
			});
		}
	}, [initialData]);

	// Active lookup that checks keys (Full Names) and updates values (Codes)
	const handleNameLookup = (fieldPrefix, enteredName, dataDictionary) => {
		let matchedCode = '';

		// Loop keys to find a case-insensitive match for the full name
		const foundKey = Object.keys(dataDictionary).find((key) => key.toLowerCase() === enteredName.toLowerCase());

		if (foundKey) {
			matchedCode = String(dataDictionary[foundKey]).toUpperCase();
		}

		setFormData((prev) => ({
			...prev,
			[`${fieldPrefix}Name`]: enteredName,
			[`${fieldPrefix}Code`]: matchedCode,
		}));
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		onSave(formData);
	};

	return (
		<form onSubmit={handleSubmit} className="amm-form-workspace">
			{/* Team Name Input */}
			<div className="mb-2">
				<label className="form-label small fw-bold text-dark mb-1">Team Designation / Name</label>
				<input type="text" className="form-control form-control-sm text-uppercase fw-bold" placeholder="e.g. A TEAM, B TEAM" value={formData.relayName} onChange={(e) => setFormData({ ...formData, relayName: e.target.value })} required />
			</div>

			{/* Club Registry Fields */}
			<div className="mb-2">
				<label className="form-label small fw-bold text-dark mb-1">Club / School Registry</label>
				<div className="row g-2">
					<div className="col-8">
						<input type="text" list="amm-form-club-names" className="form-control form-control-sm" placeholder="Type to search Club or School Full Name" value={formData.clubName} onChange={(e) => handleNameLookup('club', e.target.value, clubsList)} required />
						<datalist id="amm-form-club-names">
							{Object.keys(clubsList).map((name) => (
								<option key={name} value={name} />
							))}
						</datalist>
					</div>
					<div className="col-4">
						<input type="text" className="form-control form-control-sm text-uppercase text-center font-monospace fw-bold bg-light text-muted" placeholder="Code" value={formData.clubCode} readOnly />
					</div>
				</div>
			</div>

			{/* Country Designation Fields */}
			<div className="mb-3">
				<label className="form-label small fw-bold text-dark mb-1">Country Designation</label>
				<div className="row g-2">
					<div className="col-8">
						<input type="text" list="amm-form-country-names" className="form-control form-control-sm" placeholder="Type to search Country Name" value={formData.countryName} onChange={(e) => handleNameLookup('country', e.target.value, countriesList)} required />
						<datalist id="amm-form-country-names">
							{Object.keys(countriesList).map((name) => (
								<option key={name} value={name} />
							))}
						</datalist>
					</div>
					<div className="col-4">
						<input type="text" className="form-control form-control-sm text-uppercase text-center font-monospace fw-bold bg-light text-muted" placeholder="Code" value={formData.countryCode} readOnly />
					</div>
				</div>
			</div>

			{/* Sex Code Selector Only */}
			<div className="mb-4">
				<label className="form-label small fw-bold text-dark mb-1">Sex Designation</label>
				<select className="form-select form-select-sm fw-semibold" value={formData.sexCode} onChange={(e) => setFormData({ ...formData, sexCode: e.target.value })}>
					<option value="M">M (Male)</option>
					<option value="F">F (Female)</option>
					<option value="X">X (Mixed)</option>
				</select>
			</div>

			{/* Action Buttons */}
			<div className="d-flex justify-content-end gap-2 pt-3 border-top">
				<button type="button" className="btn btn-sm btn-light border px-3 fw-semibold text-secondary" onClick={onCancel}>
					Cancel
				</button>
				<button type="submit" className="btn btn-sm btn-primary px-4 shadow-sm fw-semibold">
					Save Team Configuration
				</button>
			</div>
		</form>
	);
};

export default RelayForm;
